export default __webpack_public_path__ + "static/media/grails.95e50bc3.svg";